<template>
  <section class="section section2">
    <div class="section-wrap">
      <div class="top-box clearfix">
        <div class="top-box-left">
          <h2 class="section2-title">{{$t("home.s2_1")}}</h2>
          <p class="section2-ps">{{$t("home.s2_2")}}</p>
          <h3 class="section2-desc" v-html='$t("home.s2_3")'>

          </h3>
          <div @click="routerSkip('/about')" class="realize-more clearfix">{{$t('common.more')}} <img src="@/assets/images/icon/more-point-right-p.png"></div>
        </div>
        <div class="top-box-right">
          <div class="rela video section2-video">
            <video id="video" ref="s2Video" :src='$t("home.s2_6")' poster="@/assets/images/tech/video.png" controls="false"></video>
            <div class="abso full" :style="'top:0;left:0;background:url('+require('@/assets/images/home/video-cover.jpg')+') no-repeat center/cover'" v-show="!videoPlay"></div>
            <div class="abso video-btn" id="video-btn" @click="videoEvent" v-show="!videoPlay">
              <img src="@/assets/images/home/video-btn.png">
              <p>{{$t("home.s2_5")}}</p>
            </div>
          </div>
          <div class="bottom-box">
            <div class="num-box" v-for='(item,index) in $t("home.s2_4")' :key="index">
              <div class="num-title"><span>{{item.t1}}</span><i>{{item.t2}}</i></div>
              <div class="num-desc">{{item.t3}}</div>
            </div>

          </div>


        </div>
      </div>
      
    </div>
  </section>
</template>

<script>
    import { IsPC } from '@/utils/autoScale'
  export default {
    name: 'homeSection2',
    data () {
      return {
        videoPlay:false,
      }
    },
    created () {
      this.getList()
    },
    mounted () {
        var _this=this
        if(!IsPC()){
            document.getElementById("video").addEventListener("pause",function(){
                // console.log(666666666666)
                _this.videoPlay=false
            },false)
            document.getElementById("video").addEventListener("play",function(){
                // console.log(7777777777)
                _this.videoPlay=true
            },false)
        }
    },
    methods: {
      getList() {

      },
      videoEvent(){
        this.videoPlay=true
        document.getElementById("video").play()
        document.getElementById("video-btn").style.display="none"
      }
    },
    computed: {

    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .English .section2 .top-box .top-box-left{margin-top:-.6rem;padding-top:.24rem;
    .section2-desc{line-height:.24rem}
  
}
  .section2
    background-image url("~@/assets/images/home/2-bg.jpg");bgContain()
    .section-wrap
      min-height 9.25rem;padding-top 1.08rem;padding-bottom 1.14rem;
    .top-box
      rela();min-height:7rem
      .top-box-left
        fl();width 40%;overflow: hidden
        .section2-title
          font-size .36rem;font-weight normal;color $standardColor
        .section2-ps
          margin-top .08rem;color $standardColor
        .section2-desc
          margin-top .25rem;padding-right .3rem;text-align justify;line-height .32rem;color #595757
      .realize-more
        width: 1.05rem;height: .36rem;border-bottom .02rem solid #595757;line-height .34rem;cursor pointer;margin-top:.32rem
        img
          fr();margin-top .08rem;width: .24rem;height: .16rem;
      .top-box-right
        fr();width 60%;abso();top:0;bottom:0;margin:auto;right:0;height:7.02rem;
        .section2-video
          width: 100%;height: 4.68rem;
    .bottom-box
      display table;width 100%;height: 2.34rem;border 1px solid #e5e5e5
      .num-box
        display table-cell;width: 20%;height: 2.36rem;border-left 1px solid #e5e5e5;vertical-align middle;text-align center;background-color #fff;
        .num-title
          margin-bottom .1rem;font-size .48rem;color #333333
          i
            font-size .5em
        .num-desc
          margin-top .1rem;color #666666
      .num-box:first-child
        border-left 1px solid transparent

  >>>.video-player
    width: 100%;height: 100%;font-size .16rem !important
    >div
      width: 100% !important;height: 100% !important;
  >>>.video-js .vjs-mute-control
    outline none
  #s2Video
    width: 100%;height: 100%
    >>>.vjs-play-progress
      padding-top 5px !important

  .video{height:4.4rem;width:100%;display: block;    overflow: hidden; }
  video{width:100%;height:100%;}
  .video{background:#000 ;border-top-left-radius: .05rem;border-top-right-radius:.05rem}
</style>
